<template>
  <v-row>
    <Receivers @select="selectedRecievers" ref="receivers" @sendtoall="senToAll"/>
    <Compose 
      :shouldSendToAll="shouldSendToAll" 
      :selectedRecipientsID="selectedRecipientsID" 
      @clearReceipients="clearReceipients"
      @openSnackbar="openParentSnackBar"
      ref="compose"
      @sendToAllStarted="sendToAllStarted"
      />
  <v-col cols="12" md="6"> </v-col>
  <csr-notification-page-send-to-all-loading-dialog :is-open.sync="isSendToAllStart" />
</v-row>
</template>

<script>

import CsrNotificationPageSendToAllLoadingDialog from "@/components/csr-notification-page/SendToAllLoadingDialog";
import Receivers from './newtab/Receivers';
import Compose from './newtab/Compose'

export default {
  name: 'NewNotification',
  components: { Receivers, Compose, CsrNotificationPageSendToAllLoadingDialog },
  data () {
    return {
      isSendToAllStart: false,
      selectedRecipientsID: [],
      shouldSendToAll: false
    }
  },
  methods: {
    prefillForm (params) {
      this.clearReceipients();
      this.$refs.receivers.setReceivers(params.users);
      this.$refs.compose.prefillForm(params);
    },
    openSnackbar (params) {
      if (params.type != undefined) {
        if (params.type == 'sent') {
          this.clearReceipients();
        }
      }
      this.openParentSnackBar(params);
    },
    openParentSnackBar (params) {
      this.$emit('openSnackbar', params);
    },
    selectedRecievers (params) {
      this.selectedRecipientsID = params.receivers;
    },
    senToAll (params) {
      this.shouldSendToAll = params.sendToAll
    },
    clearReceipients () {
      this.selectedRecipientsID = [];
      this.$refs.receivers.clearReciepients();
    },
    sendToAllStarted (params) {
      this.isSendToAllStart = params.value;
    }
  }
}
</script>